<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
  color: white;
  text-align: center;
}

.slider{
  padding: 0 20px;
}
</style>

<div class="bg">
  <div class="title-signup">What is your age preference for meeting other people?</div>
  
  <div class="margin slider">
    <RangeSlider id="price" min="{18}" max="{120}" pushy range float bind:values="{agePreference}" springValues="{ { stiffness: 0.25, damping: 0.9 } }"></RangeSlider>
  </div>
  
  <div class="margin">{agePreference[0]} - {agePreference[1]}</div>

  <div class="has-buttons"></div>
  
</div>

<!-- <div class="next">
  <button on:click="{next}" disabled="{nextDisabled}">Next</button>
</div> -->
<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import RangeSlider from "svelte-range-slider-pips";
import NextButton from "../../../../components/NextButton.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";

import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;
  // Signup.saveToPersonalObject("agePreference", "");
  agePreferenceSaved = Signup.getPersonalObject("agePreferenceSaved");
  agePreference = Signup.getPersonalObject("agePreference");
  
  if (agePreference.length == 0) {
    // set a reasonable default
    let birthday = Signup.getPersonalObject("birthday"); // mysql style date
    
    let bd = birthday.split("-");
    let year = parseInt(bd[0]);
    let curYear = new Date().getFullYear();
    // console.log("year:", year);
    
    agePreference[0] = curYear - year - 10;
    agePreference[1] = curYear - year + 10;
    
    if (agePreference[0] < 18) agePreference[0] = 18;
    if (agePreference[1] > 120) agePreference[1] = 120;
  }
  
  if (agePreferenceSaved == true) {
    nextDisabled = false;
  } else {
    check();
  }
  
});

let allowSignup = false;
let agePreference = [18,120];
let agePreferenceSaved = false;
let nextDisabled = true;


function check() {
  agePreferenceSaved = false;
  try {
    Validate.allowSignup(allowSignup);
    nextDisabled = false;
  } catch (e) {
    nextDisabled = true;
    console.log("error:", e);
  }
}


async function next() {
  if (agePreferenceSaved == false) {
    await Signup.saveToPersonalObject("agePreference", agePreference);
    await Signup.saveToPersonalObject("agePreferenceSaved", true);
    await Signup.saveMe("agePreference");
  }
  
  push("/signup/profile/personal/looking-for");
}


</script>